import { Component } from "react";
import TalaeraRoutes from "./../../../../../routes/TalaeraRoutes";
import SidePanelSection from "./../../../SidePanelSection/SidePanelSection";
import { Link } from "react-router-dom";

export class HomeworkFilter {
  static GROUPED_BY_CONTENT = {
    filterName: "", // Default view then.
    name: "Grouped by content",
  };
  static UNFINISHED = {
    filterName: "unfinished",
    name: "Unfinished",
  };
  static RECENTLY_COMPLETED = {
    filterName: "recently",
    name: "Recently completed",
  };
  static COMPLETED = {
    filterName: "completed",
    name: "Completed history",
  };
  static SAVED_BY_MYSELF = {
    filterName: "saved_by_myself",
    name: "Saved by myself",
  };

  static getAll() {
    return [
      HomeworkFilter.GROUPED_BY_CONTENT,
      HomeworkFilter.UNFINISHED,
      HomeworkFilter.RECENTLY_COMPLETED,
      HomeworkFilter.COMPLETED,
      HomeworkFilter.SAVED_BY_MYSELF,
    ];
  }
}

export default class HomeworkSidePanel extends Component {
  render() {
    const list = HomeworkFilter.getAll();
    return (
      <SidePanelSection
        sectionTitle="My Homework"
        list={list}
        location={this.props.location}
        tagName={HomeworkListItem}
      />
    );
  }
}

class HomeworkListItem extends Component {
  render() {
    const path = TalaeraRoutes.buildHomeworkPath(this.props.item.filterName);
    return (
      <li className={path === this.props.location.pathname ? "active" : ""}>
        <Link className="btn" to={path}>
          {this.props.item.name}
        </Link>
      </li>
    );
  }
}
